import React from 'react';
import { LessonPage } from './LessonPage';

export class LessonList extends React.Component {
  constructor(props) {
    super(props);

    this.pageIndex = 0;
  }

  render() {
    return (
      <LessonPage onLessonSelected={this.props.onLessonSelected} />
    )
  }
}

